import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Sparkles } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { WhatsNewAdminPage } from "./pages/WhatsNewAdminPage";

export const whatsNewModule: FeatureModule = {
  key: "whats_new",
  nav: {
    label: "What's New",
    icon: Sparkles,
    to: "/whats-new",
    requires: "whats_new.admin",
    order: 95,
    group: "Overview",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/whats-new",
      component: guarded("whats_new.admin", WhatsNewAdminPage),
    }),
  ] as unknown as AnyRoute[],
};
